"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getProviderImageUrl = getProviderImageUrl;
exports.getProviderLogoObjects = getProviderLogoObjects;
var _assets = require("./constants/assets");
var _provider = require("./provider");
/**
 * Returns the url for the providers image or an appropriate default avatar.
 * @param {object} provider An object containing provider data.
 * @return {string} The appropriate url for the provider image.
 */
function getProviderImageUrl(provider) {
  let providerImageURL = provider.image_url;
  if (!providerImageURL) {
    if (provider.gender === 'Female') {
      providerImageURL = _assets.FEMALE_PROVIDER_AVATAR_URL;
    } else if (provider.gender === 'Male') {
      providerImageURL = _assets.MALE_PROVIDER_AVATAR_URL;
    } else {
      providerImageURL = _assets.NEUTRAL_PROVIDER_AVATAR_URL;
    }
  }
  return providerImageURL;
}

/**
 * Based on the provider and customer config, returns logos that are applicable to provider
 * @param {object} provider An object containing provider data.
 * @param {object[]} logoConfigs An array of logo config objects for the customer.
 * @param {object[]} facets An array of facet data from the customer config.
 * @return {object[]} An array of objects representing the logos a provider can display
 */
function getProviderLogoObjects(provider) {
  let logoConfigs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let facets = arguments.length > 2 ? arguments[2] : undefined;
  const providerLogos = [];
  for (const logoConfig of logoConfigs) {
    if (logoConfig.show_in_search_results) {
      for (const fieldValue of (0, _provider.getSummaryFieldValues)(provider, facets, logoConfig)) {
        const logo = logoValue(logoConfig, fieldValue);
        if (logo) {
          providerLogos.push({
            logo_name: fieldValue.primary,
            logo_url: logo
          });
        }
      }
    }
  }
  return providerLogos;
}

/**
 * Iterates through the logos of a config to see if they match the passed in field value.
 * @param {object} logoConfig A logo config object from the customer.
 * @param {object} fieldValue A fieldValue representing a partial summary of a provider.
 * @return {string || null} The corresponding url string if a match, otherwise null.
 */
function logoValue(logoConfig, fieldValue) {
  if (logoConfig.logo_map && logoConfig.logo_map.length) {
    for (const logo of logoConfig.logo_map) {
      if (logo.value === fieldValue.primary) {
        return logo.img_url;
      }
    }
  }
  return null;
}